import { IEquatable } from "../IEquatable";

export class Set2<TI extends IEquatable<TI>> {
    private readonly hashMap = new Map<number, TI[]>();

    public constructor(source?: Iterable<TI>) {
        if (source != undefined) {
            for (const sourceElement of source) {
                this.add(sourceElement);
            }
        }
    }

    public add(path: TI): boolean {
        const hash = this.getItemHash(path);
        const list = this.hashMap.get(hash);
        if (list == undefined) {
            this.hashMap.set(hash, [path]);
            return true;
        } else {
            if (list.find(x => this.areItemsEqual(x, path)) == undefined) {
                list.push(path);
                return true;
            }
        }
        return false;
    }

    public remove(path: TI): void {
        const hash = this.getItemHash(path);
        const list = this.hashMap.get(hash);
        if (list != undefined) {
            this.hashMap.set(
                hash,
                list.filter(x => !this.areItemsEqual(x, path))
            );
        }
    }

    public has(path: TI): boolean {
        const hash = this.getItemHash(path);
        return this.hashMap.get(hash)?.find(x => this.areItemsEqual(x, path)) != undefined;
    }

    public isEmpty(): boolean {
        return this.hashMap.size === 0;
    }

    public values(): Iterable<TI> {
        return Iterator.from(this.hashMap.values()).flatMap(x => x);
    }

    public clear(): void {
        this.hashMap.clear();
    }

    protected getItemHash(key: TI): number {
        return key.getHash();
    }

    protected areItemsEqual(left: TI, right: TI): boolean {
        return left.isEquals(right);
    }
}
